import { fromJS, List } from 'immutable';
import * as _ from 'lodash';
import * as R from 'ramda';

import { fetchingState } from '@constants';

import * as actions from '../actions/messages';

const normalizeByKey = key => array =>
  array.reduce((acc, el) => {
    acc[el[key].toString()] = el;
    return acc;
  }, {});

const initialState = fromJS({
  messages: { data: {}, state: null },
  childMessages: { data: {}, state: null },
});

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_MESSAGES_START: {
      return state.setIn(['messages', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CHILD_MESSAGES_START: {
      return state.setIn(
        ['childMessages', action.messageId.toString(), 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_MESSAGES_SUCCESS: {
      return state.setIn(['messages', 'state'], fetchingState.LOADED).setIn(
        ['messages', 'data'],
        R.compose(
          fromJS,
          normalizeByKey('messageID'),
        )(_.get(action, 'data.results', [])),
      );
    }
    // case actions.DELETE_MESSAGE_FILE_START:
    // case actions.INSERT_MESSAGE_FILE_START: {
    //   return state.setIn(['messages', 'state'], fetchingState.FETCHING);
    // }

    case actions.DELETE_MESSAGE_FILE_SUCCESS:
    case actions.INSERT_MESSAGE_FILE_SUCCESS: {
      return state
        // .setIn(['messages', 'state'], fetchingState.LOADED)
        .setIn(
          ['messages', 'data', action.messageId.toString(), 'fileAttachments'],
          fromJS(_.get(action, 'data.results[0].fileAttachments', [])),
        ).setIn(
          ['messages', 'data', action.messageId.toString(), 'updateDt'],
          fromJS(_.get(action, 'data.results[0].updateDt', null)),
        );
    }
    case actions.INSERT_CHILD_MESSAGE_SUCCESS: {
      return state.updateIn(
        ['childMessages', action.payload.parentMessageID.toString(), 'data'],
        messages => {
          return messages.concat(new List(_.get(action, 'data.results', [])));
        },
      );
    }
    case actions.FETCH_CHILD_MESSAGES_SUCCESS: {
      return state.setIn(
        ['childMessages', action.messageId.toString(), 'data'],
        new List(_.get(action, 'data.results', [])),
      );
    }

    case actions.FETCH_CHILD_MESSAGES_ERROR: {
      return state.setIn(
        ['childMessages', action.messageId.toString(), 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.DELETE_MESSAGE_FILE_ERROR:
    case actions.INSERT_MESSAGE_FILE_ERROR: {
      return state.setIn(
        ['messages', 'data', action.messageId.toString(), 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.FETCH_MESSAGES_ERROR: {
      return state.setIn(['messages', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default messagesReducer;
